import React, { useCallback } from 'react';

import { useActionItemContext } from '../../context';
import { StaticAssignMenuProps } from '../../types';
import StaticAssignMenuPopover from './StaticAssignMenuPopover';

const StaticAssignMenu = ({ participants, className, fixedWidth }: StaticAssignMenuProps) => {
  const {
    actionItem: { assignedToId, id, assignedTo },
    actions,
    isReadOnly,
  } = useActionItemContext();

  const onClick = useCallback(
    (userId: string) => {
      actions?.onAssignClick(userId, id);
    },
    [actions, id],
  );

  const selectedUser =
    participants.find((participant) => participant.id === assignedToId) ?? assignedTo ?? undefined;

  return (
    <StaticAssignMenuPopover
      className={className}
      fixedWidth={fixedWidth}
      isDisabled={isReadOnly}
      participants={participants}
      selectedUsers={selectedUser ? [selectedUser] : []}
      onClick={onClick}
    />
  );
};

export default React.memo(StaticAssignMenu);
